import { render, staticRenderFns } from "./TransferFormWorkflow.vue?vue&type=template&id=6c3172ac"
import script from "./TransferFormWorkflow.vue?vue&type=script&lang=js"
export * from "./TransferFormWorkflow.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TransferFormWorkflow.vue?vue&type=style&index=1&id=6c3172ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports